import React from 'react';
import { Controller } from 'react-hook-form';
import LabelName from 'components/UI/LabelName/LabelName';
import PracticeAreaSelect from 'components/UI/PracticeAreaSelect/PracticeAreaSelect';

function EventPracticeArea({ control }) {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12">
        <LabelName required={false} htmlFor="practice_area">
          Practice Area
        </LabelName>
      </div>
      <div className="col-md-8 col-12">
        <Controller
          name="practice_area"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <PracticeAreaSelect
              id={field.name}
              name={field.name}
              value={field.value}
              onChange={(value) => field.onChange(value || '')}
              onBlur={field.onBlur}
              placeholder="Select practice area"
              isClearable={false}
              isSearchable={false}
              className="w-100"
            />
          )}
        />
      </div>
    </div>
  );
}

export default EventPracticeArea;
